import { render, staticRenderFns } from "./ElectronicBill.vue?vue&type=template&id=6ff60e38&"
import script from "./ElectronicBill.vue?vue&type=script&lang=js&"
export * from "./ElectronicBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports